var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100",attrs:{"id":"app"}},[(_vm.user.name)?_c('main-menu'):_vm._e(),_c('router-view'),_c('trial-expired-modal'),(_vm.should_record)?_c('recorder'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }